// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__RPoak","col":"CardReaderDesc_col__GNfUZ","label":"CardReaderDesc_label__tJxkk"};